module.exports = __webpack_public_path__ + "media/assets/images/flags/km-a01b7e76ce125e217aee85177965cb26.svg";